// removed by extract-text-webpack-plugin
module.exports = {"Heading":"roomSettings__Heading__3THFv"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Dashboard/MainContent/roomSettings.css
// module id = 1708
// module chunks = 2